import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Field, reduxForm } from 'redux-form'
import {SortableContainer, SortableElement, arrayMove, SortableHandle} from 'react-sortable-hoc';
import shortid from 'shortid';
import Dropdown from 'react-dropdown';

import { tryToCalculatePattern, pmUpdateFromHybrid, updateFromScale, showTooltip, hideTooltip } from '../../actions/actions.export.js';
import CustomField from '../CustomField/CustomField.js'
import Button from '../Button/Button.js'
import canI from '../../canI.js';

import './CalculatorEditor.css';

class CalculatorEditor extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }
  
  constructor(props){
    super(props);

    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleScaleFactorChange = this.handleScaleFactorChange.bind(this);
    this.toggleLink = this.toggleLink.bind(this);
    this.setHoveredLinkVariables = this.setHoveredLinkVariables.bind(this);
    this.handleRegenerate = this.handleRegenerate.bind(this);

    this.state = {
      linkedTo: []
    }
  }


  setHoveredLinkVariables(linkedTo){
    // console.log(linkedTo);
    this.setState({
      linkedTo: linkedTo || []
    })
  }


  handleFieldChange(i, value){
    const { dispatch, patternManager, cacheID } = this.props;
    var pattern = patternManager.cache[cacheID];

    // we need to create a new copy of these and pass that to the api,
    // so that when the api call is complete, the history can be properly logged.

    var variables = JSON.parse(JSON.stringify(pattern.variables)); 
    var scale_factor = pattern.scale_factor;
    var calculator = pattern.calculator;
    
    variables[i].value = parseFloat(value);
    
    dispatch(tryToCalculatePattern({
      id: pattern.id,
      cacheID: cacheID,
      calculator: calculator,
      scale_factor: scale_factor,
      variables: variables
    }))
  }

  handleRegenerate(){
    const { dispatch, patternManager, cacheID } = this.props;
    var pattern = patternManager.cache[cacheID];
    
    dispatch(tryToCalculatePattern({
      id: pattern.id,
      cacheID: cacheID,
      calculator: pattern.calculator,
      scale_factor: pattern.scale_factor,
      variables: pattern.variables
    }))
  }

  toggleLink(i){
    const { dispatch, patternManager, cacheID } = this.props;
    var pattern = patternManager.cache[cacheID];
    
    pattern.variables[i].linked = !pattern.variables[i].linked;

    dispatch(tryToCalculatePattern({
      id: pattern.id,
      cacheID: cacheID,
      calculator: pattern.calculator,
      scale_factor: pattern.scale_factor,
      variables: pattern.variables
    }))
  }

  handleScaleFactorChange(value){
    const { dispatch, patternManager, cacheID } = this.props;
    
    dispatch(updateFromScale({
      cacheID: cacheID,
      pattern: { scale_factor: parseFloat(value) }
    }))
  }

  render(){
    const { patternManager, dispatch, cacheID, user, team } = this.props; 
    var pattern = patternManager.cache[cacheID];
    var that = this;

    var variables = pattern.variables || [];

    let lockedOut = false;
    if(pattern.calculator !== 'hech1b'){
      if(!user.isLoggedIn) lockedOut = true;
      if(!user.roles.pro) lockedOut = true;

      if(team.current && team.cache[team.current]) lockedOut = false;
    }

    if(this.props.demo) lockedOut = false;

    // console.log('render', pattern.variables);
    
    return (
      <div className="calculator-wrapper">
        {
          lockedOut && <div className="calculator-notes">
            <span className="text-danger"> <i className="fad fa-exclamation-triangle fa-lg"/> &nbsp;<strong>Unauthorized:</strong> Only Pro accounts and Teams can edit template values.</span>
          </div>
        }
        <table className="calculator-table">
          <tbody>
            {
              variables.map(function(v, i){
                return <tr className="calculator-row" key={'v_' + i + '_' + v.linked}>
                  <td className="calculator-label">{ v.display }</td>
                  <td className={"calculator-field" + ((v.linked || v.locked || lockedOut) ? ' calculator-field-disabled ' : '') + (that.state.linkedTo.indexOf(v.name) > -1 ? ' calculator-field-linked-to ' : '')}>
                    <Field 
                      name={'variables[' + i + ']'} 
                      component="input" 
                      type="number" 
                      disabled={lockedOut}
                      onChange={(e) => { that.handleFieldChange(i, e.target.value)}}
                    />
                  </td>
                  <td className="calculator-type-label">
                    {
                      v.type === 'units' ? 
                      ( pattern.format == 'AUTOCAD' ? 'UNITS' : 
                        (pattern.units === 'INCH' ? 'INCHES' : 'Millimeters')
                      )
                      : 
                      v.type
                    }
                  </td>
                  <td className={"calculator-linked-locked " + ((v.canBeLinked && !canI(user, team, 'linked_template_fields', team.current)) ? "calculator-locked":"")}>
                    {
                      (v.canBeLinked && canI(user, team, 'linked_template_fields', team.current)) && <span 
                        onClick={(e) => { that.toggleLink(i) }} 
                        onMouseEnter={(e) => { that.setHoveredLinkVariables(v.linkedTo) }}
                        onMouseLeave={(e) => { that.setHoveredLinkVariables() }}
                        key={shortid.generate()}
                        >
                        {
                          v.linked ? <i key={shortid.generate()} className="fas fa-link"/> : <i key={shortid.generate()} className="fas fa-unlink"/>
                        }
                      </span>
                    }
                    {
                      (v.canBeLinked && !canI(user, team, 'linked_template_fields', team.current)) && <span className="pro-only">
                        <i className="fas fa-lock"/> PRO ONLY
                      </span>
                    }
                  </td>
                </tr>
              })
            }
            {
              pattern.hasRandom && <tr>
                <td colSpan="4" className="calculator-notes">
                  <div className="list-left">
                    <span
                      onMouseEnter={(e)=>{ dispatch(showTooltip({
                        e: e,
                        position: 'top',
                        nobr: false,
                        lag: 1000,
                        content: <div style={{width: 150}}>
                          Regenerate the random values in this pattern. {lockedOut && <i className="fad text-award fa-award"/>}
                        </div>
                      })) }}
                      onMouseLeave={(e) =>{ dispatch(hideTooltip()) }}
                      >
                      <Button 
                        size="medium" 
                        display={<span><i className="far fa-sync-alt fa-fw"/> &nbsp;Regenerate</span>}
                        color="grey" 
                        onClick={this.handleRegenerate}
                        disabled={lockedOut}
                        thinking={patternManager.tryingToCalculatePattern}
                        />
                    </span>
                  </div>
                </td>
              </tr>
            }
            {
              pattern.notes && <tr>
                <td colSpan="4" className="calculator-notes">
                  <strong>Tip:</strong> {pattern.notes}
                </td>
              </tr>
            }
            {
              (!lockedOut && !patternManager.tryingToCalculatePattern && !patternManager.calculatorError) && <tr>
                <td colSpan="4" className="calculator-notes">
                  <i className="fas fa-check text-success fa-lg"/> &nbsp;<strong>Pattern successfully generated.</strong>
                </td>
              </tr>
            }
            {
              (patternManager.tryingToCalculatePattern) && <tr>
                <td colSpan="4" className="calculator-notes text-muted">
                  <i className="fas fa-spinner-third fa-spin fa-lg"/> &nbsp;<strong>Calculating...</strong>
                </td>
              </tr>
            }
            {
              (!patternManager.tryingToCalculatePattern && patternManager.calculatorError) && <tr>
                <td colSpan="4" className="calculator-notes text-danger">
                  <i className="fad fa-exclamation-triangle fa-lg"/> &nbsp;<strong>Error: Your inputs resulted in an invalid .PAT file.</strong>
                </td>
              </tr>
            }
            {
              lockedOut && <td colSpan="4">
                <small><Link to="/feature-table" className="text-grey-primary">Compare Pattycake Pro & Team plans in detail&nbsp; <i className="far fa-angle-right"/></Link></small>
              </td>
            }
          </tbody>
        </table>

      </div>
    )
  }
}


CalculatorEditor = reduxForm({
  // a unique name for the form
  form: 'CalculatorEditor',
  enableReinitialize: true,
  destroyOnUnmount: false
})(CalculatorEditor)


CalculatorEditor = connect((state, ownProps) => {
  const { patternManager, user, team } = state;

  var variables = [];
  for(var i in patternManager.cache[ownProps.cacheID].variables){
    variables.push(patternManager.cache[ownProps.cacheID].variables[i].value);  
  }

  var initialValues = {
    variables: variables,
    // scale_factor: patternManager.cache[ownProps.cacheID].scale_factor === undefined ? 1 : patternManager.cache[ownProps.cacheID].scale_factor
  };

  // console.log('init', variables);

  return {
    patternManager,
    initialValues,
    user,
    team,
    state
  }
})(CalculatorEditor);


export default CalculatorEditor;


// WEBPACK FOOTER //
// ./src/components/CalculatorEditor/CalculatorEditor.js